import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Select,
} from '@chakra-ui/react';
import { ErrorMessage } from '@hookform/error-message';
import type { SnapSiteConfigEditFormDataUnvalidated } from '@snap-types/models/snap-site-config';
import type { FieldPathFn } from '@ui/components/form';
import { useSnapSiteConfigEditContext } from '@ui/features/snap-site-config/screens/edit/context/hook';
import { get, useFormContext } from 'react-hook-form';

export function RAFFixedMarketForm({
  fieldPath,
}: {
  fieldPath: FieldPathFn<SnapSiteConfigEditFormDataUnvalidated>;
}) {
  const form = useFormContext();
  const { marketCodes } = useSnapSiteConfigEditContext();

  const marketCodeFieldPath = fieldPath('marketCode');
  const marketCodeFieldError = get(form.formState.errors, marketCodeFieldPath);

  return (
    <FormControl isInvalid={!!marketCodeFieldError} isRequired>
      <FormLabel htmlFor={marketCodeFieldPath}>Market Code:</FormLabel>

      <Select {...form.register(marketCodeFieldPath)} id={marketCodeFieldPath}>
        {marketCodes.map((code) => (
          <option key={code} value={code}>
            {code}
          </option>
        ))}
      </Select>

      <ErrorMessage
        name={marketCodeFieldPath}
        render={({ message }) => <FormErrorMessage>{message}</FormErrorMessage>}
      />
    </FormControl>
  );
}
